const deliveryQueryData = (escalatedComplaintsEnabled, missingItemEmailFormEnabled) => {
  let options = {
    id: "deliveryQuery",
    type: "select",
    select: {
      label: "What can we help with?",
      options: [
        {
          value: null,
          label: "Select a subject",
        },
        {
          value: "amendDelivery",
          label: "Amend delivery",
        },
        {
          value: "trackDelivery",
          label: "Track order",
        },
        {
          value: "damagedOnDeliveryFurniture",
          label: "Furniture was damaged when delivered",
        },
        {
          value: "damagedOnDeliveryNonFurniture",
          label: "Other products damaged when delivered",
        },
        {
          value: "deliveryQueryOther",
          label: "Other",
        },
      ],
    },
  };

  if (escalatedComplaintsEnabled) {
    const selectedIndex = options.select.options.findIndex(option => option.value === "deliveryQueryOther");
    const newOptions = [
      {
        value: "gasOrWaterLeak",
        label: "Gas / water leak",
      },
    ];
    options.select.options = [
      ...options.select.options.slice(0, selectedIndex),
      ...newOptions,
      ...options.select.options.slice(selectedIndex),
    ];
  }

  if (missingItemEmailFormEnabled) {
    const selectedIndex = options.select.options.findIndex(option => option.value === "damagedOnDeliveryNonFurniture");

    const newOptions = [
      {
        value: "missingItem",
        label: "My item is missing",
      },
    ];

    options.select.options = [
      ...options.select.options.slice(0, selectedIndex + 1),
      ...newOptions,
      ...options.select.options.slice(selectedIndex + 1),
    ];
  }
  return options;
};

export default deliveryQueryData;
